export const DELAY_TIME = {
  initialTime: 2,
  nextCallTime: 28,
}
